import { render, staticRenderFns } from "./note-rule-form.vue?vue&type=template&id=3a8c7f7f&"
import script from "./note-rule-form.vue?vue&type=script&lang=js&"
export * from "./note-rule-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports